import { DataItem } from 'scrivito'

const PISA_SALES_LINK = 'pisaSalesLink'

export const getPisaSalesDeepLink = (dataItem?: DataItem) => {
  return (dataItem?.get(PISA_SALES_LINK) as string) || ''
}
